import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';

import { UserSidebar_user$key } from '__generated__/UserSidebar_user.graphql';

type Props = {
  user: UserSidebar_user$key;
};

const UserSidebar: FC<Props> = props => {
  const user = useFragment(
    graphql`
      fragment UserSidebar_user on User {
        ...EntitySidebar_entity
      }
    `,
    props.user
  );

  return <EntitySidebar entity={user} />;
};

export default UserSidebar;
